import { graphql } from 'gatsby';
import React from 'react';

import ReferALandlord from '../components/ReferALandlord';

const ReferALandlordPage = (): JSX.Element => {
  return <ReferALandlord />;
};

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;

export default ReferALandlordPage;
